import api from './api';
import {
  LoginCredentials,
  LoginResponse,
  RegisterUserData,
  RegisterResponse,
  VerifyTokenResponse,
} from '@/types';

export const authApi = {
  /**
   * Login user
   */
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const { data } = await api.post<LoginResponse>('/auth/login', credentials);
    return data;
  },

  /**
   * Register new user (admin only)
   */
  register: async (userData: RegisterUserData): Promise<RegisterResponse> => {
    const { data } = await api.post<RegisterResponse>('/auth/register', userData);
    return data;
  },

  /**
   * Verify JWT token
   */
  verifyToken: async (): Promise<VerifyTokenResponse> => {
    const { data } = await api.get<VerifyTokenResponse>('/auth/verify');
    return data;
  },
};
